<template>
	<div class="info-wrapper">
		<p><span class="title">{{translation.title}}</span></p>
		<div class="info-description">
			<p>{{translation.vaccine}} <a class="link" :href="translation.url">www.visitbrasil.com/key-information/health.html.</a></p>
			<p>{{translation.vaccineInfo}}, <a class="link" href="http://www.portalconsular.itamaraty.gov.br/images/qgrv/QGRV-simples-ing-Novo-190617.pdf">{{translation.click}}</a></p>
			<br>
			<p><i>{{translation.vaccineMoreInfo}}</i></p>
		</div>
	</div>
</template>

<script>
import { translate } from '../../assets/translations';
export default {
	props: ['event'],
	data(){
		return{
		}
	},
	computed:{
			/** @returns {Object} */
		translation() {
			return translate(this.$store.state.language).visaAndVaccine;
		},
	},
	created() {
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>

.link{
	color: blue;
}
.title{
	font-size: 20px;
	color: #253b6d;
	margin-bottom: 2%;
}

.info-description{
		color: #686868;
		border: 1px solid #D7D7D7;
    font-size: 12px;
		padding: 10px;
    margin: 0 auto;
    text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/visa-and-vaccine/VisaAndVaccine.vue